const dropdowns = [...document.querySelectorAll('.js-dropdown')];


dropdowns.forEach((dropdown) => {
    const menu = dropdown.querySelector('.js-dropdown__menu');
    const toggle = dropdown.querySelector('.js-dropdown__toggle');
    const carot = dropdown.querySelector('.js-dropdown__menu-carot');

    const menuRect = menu.getBoundingClientRect();
    const offset = (menuRect.width + menuRect.left + 50) - window.innerWidth;
    menu.style.transform = `translateX(-${offset}px)`;
    carot.style.transform = `translateX(${Math.max(0, offset) + (dropdown.offsetWidth / 2)}px)`;

    let timeout = null;

    if (toggle) {
        toggle.addEventListener('click', () => {
            dropdowns
                .filter(d => d !== dropdown)
                .forEach((d) => { d.classList.remove('is-open'); });
            dropdown.classList.toggle('is-open');
        });
    }

    dropdown.addEventListener('mouseover', () => {
        dropdowns
            .filter(d => d !== dropdown)
            .forEach((d) => { d.classList.remove('is-open'); });
        window.clearTimeout(timeout);
        dropdown.classList.add('is-open');
        const xOffset = (menuRect.width + menuRect.left + 50) - window.innerWidth;
        menu.style.transform = `translateX(-${xOffset}px)`;
        carot.style.transform = `translateX(${Math.max(0, xOffset) + (dropdown.offsetWidth / 2)}px)`;
    });

    dropdown.addEventListener('mouseleave', () => {
        timeout = window.setTimeout(() => {
            dropdown.classList.remove('is-open');
        }, 1500);
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/navDropdowns.js